/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Unit} from './Unit';
import {Picture} from './Picture';
import {Manufacturer} from './Manufacturer';
import {ManufacturerSeries} from './ManufacturerSeries';
import {Brand} from './Brand';

export interface ProductElasticDTO {
  id: number;
  header: string;
  barCode?: string;
  articul?: string;
  syncUid?: string;
  content?: string;
  description?: string;
  price: number;
  enabled: boolean;
  pos: number;
  parentId?: number;
  productStatusId?: number;
  productGroupId?: number;
  supplierId?: number;
  featureUnionCondition?: number;
  catalogAdditional?: number[];
  catalogId?: number;
  width?: number;
  height?: number;
  length?: number;
  weight?: number;
  unit?: Unit;
  terms?: string[];
  picture: Picture;
  pictures: Picture[];
  /**
   * HOFFM-59: id of the first `image/*` document among the product's DAM collections
   * (`dam_item_version.id`), used by the catalog listing as a fallback image when `picture` is
   * empty. Rendered through the id-keyed DAM streaming endpoint
   * (`/dam/get-image-dynamic-version/{id}/{size}`), NOT the `picture` static-path scheme.
   */
  pictureFallback?: number;
  manufacturer?: Manufacturer;
  brand?: Brand;
  manufacturerSeries?: ManufacturerSeries;
  manufacturerHeader?: string;
  brandHeader?: string;
  manufacturerSeriesHeader?: string;
  createdAt?: Date;
  deleted?: boolean;
  features?: any;
  isMasterCard?: boolean;
  isCopy?: boolean;
  /** PIM2-449 card completeness (null when the product has no template). */
  completenessPercent?: number;
  requiredFilled?: number;
  requiredTotal?: number;
}
